'use client';

import { c as _c } from "react/compiler-runtime";
import { BaseIssue, IssueTooltipContent } from '../../../shared/issue/base-issue';
import { getGithubIssueLabel } from './github-issue-label';
import { useLinkedGithubIssueQuery } from '@/data/github-issues/use-linked-github-issue';
import { usePrStore } from '@/lib/stores/pr-store';
export function GithubIssueComponent() {
  const $ = _c(8);
  const {
    owner,
    repo,
    number
  } = usePrStore();
  let t0;
  if ($[0] !== number) {
    t0 = Number.parseInt(number, 10);
    $[0] = number;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const {
    data: issue,
    isError
  } = useLinkedGithubIssueQuery(owner, repo, t0);
  if (!issue || isError) {
    return null;
  }
  let t1;
  if ($[2] !== owner || $[3] !== repo) {
    t1 = linkedIssue_0 => getGithubIssueLabel(linkedIssue_0, {
      owner,
      repo
    });
    $[2] = owner;
    $[3] = repo;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== issue || $[6] !== t1) {
    t2 = <BaseIssue providerLabel="GitHub issue" SearchComponent={null} issue={issue} isError={false} isLoading={false} onOpenProvider={_temp} getIssueKey={t1} getIssueSummary={_temp2} tooltipContent={_temp3} />;
    $[5] = issue;
    $[6] = t1;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  return t2;
}
function _temp3(linkedIssue_2) {
  return <IssueTooltipContent label="GitHub" summary={linkedIssue_2.title} />;
}
function _temp2(linkedIssue_1) {
  return linkedIssue_1.title;
}
function _temp(linkedIssue) {
  window.open(linkedIssue.url, "_blank", "noopener,noreferrer");
}